<div>
  <h6 class="odx-title-6" i18n="@@global.operatingTheatres">Operating Theatres</h6>

  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      class="operating-theatre"
      (click)="addOperatingTheatre()"
      [odxTooltip]="tooltipText"
      [odxTooltipOptions]="{ position: 'bottom-start' }"
      draggable="true"
      (dragstart)="dragOperatingTheatre()"
    >
      <odx-icon name="plus" size="medium"></odx-icon>
    </button>
    <app-toggle-visibility-button
      [visible]="floorplanState.operatingTheatresVisible"
      (toggleEvent)="floorplanState.operatingTheatresVisible = $event"
    >
    </app-toggle-visibility-button>

    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.operatingTheatresItemTextVisible"
      (toggleEvent)="updateOperatingTheatresItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.operatingTheatresLocked"
      (toggleEvent)="floorplanState.operatingTheatresLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
